export default __webpack_public_path__ + "static/Omar-mal-fc12b6534c428fc59fd4de1a77b4c177.jpg";